import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { WrenchIcon } from "lucide-react";
import { CHECKOUT_URL } from "./constants";

/**
 * Floating CTA that appears once the user scrolls past the first hero CTA.
 * Anchored to bottom on all viewports so it stays visible on mobile.
 */
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const trigger = document.getElementById("hero-cta-anchor");
    const onScroll = () => {
      if (!trigger) {
        setVisible(window.scrollY > 600);
        return;
      }
      const rect = trigger.getBoundingClientRect();
      setVisible(rect.bottom < 0);
    };
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <AnimatePresence data-id="element-83" data-mp="14fggpxmlgdpp">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      type: "spring",
      stiffness: 260,
      damping: 26
    }} className="fixed inset-x-0 bottom-0 z-50 px-3 pb-3" data-id="element-84" data-mp="14eohmctsfxuo">
          <div className="mx-auto max-w-md" data-id="element-85" data-mp="21dfdmcthm5nj">
            <motion.a href={CHECKOUT_URL} whileTap={{
          scale: 0.97
        }} className="flex w-full items-center justify-center gap-2 rounded-xl bg-amber-400 px-4 py-4 font-display text-sm font-extrabold uppercase tracking-tight text-neutral-900 shadow-[0_-6px_30px_-4px_rgba(245,184,0,0.55)] sm:text-base" data-id="element-86" data-mp="21ajh8sxafp17">
              <WrenchIcon className="h-5 w-5 shrink-0" data-id="element-87" data-mp="1ietfn6t9ounu" />
              Quiero el Sistema Técnico PRO 360 — $12.99
            </motion.a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}